import client from './main-client';

export const fetchBrokerApi = params => client().get(`/re-broker-agencies`, { params });
export const fetchBrokersCountApi = params => client().get(`/re-broker-agencies/count`, { params });
export const updateAgencyApi = params =>
  client().put(`/re-broker-agents/${params.id}`, params.values);
export const addAgencyApi = data => client().post('/re-broker-agents', data);
export const deleteAgencyApi = params =>
  client().delete(`/re-broker-agents/${params.id}`, params.values);
